import {FormField} from "../types/enums";

export const czechMonths = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
export const czechWeekDays = ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"];
export const currencies = ["CZK", "EUR"];
export const ALL_FORM_FIELDS: FormField[] = Object.values(FormField)